import Dataset from "datasets/types/interfaces/dataset";
import { Agent, AgentStatus } from "~/services/agents";

// A project needs setup until it has at least one dataset, at least one
// agent, and — for an owner, who's the only one who can act on it — at
// least one enabled agent. Returns false while either list is still
// loading (undefined) so callers don't flash into "needs setup" before
// data arrives.
export const useProjectNeedsSetup = (
  attachedDatasets: Dataset[] | undefined,
  attachedAgents: Agent[] | undefined,
  isOwner: boolean
): boolean => {
  if (attachedDatasets === undefined || attachedAgents === undefined) {
    return false;
  }
  const hasEnabledAgent = attachedAgents.some((a) => a.status === AgentStatus.ENABLED);
  return (
    attachedDatasets.length === 0 || attachedAgents.length === 0 || (isOwner && !hasEnabledAgent)
  );
};
